export class SendEmailException extends Error {}
export class TemplateException extends Error {}
export class UnsubscribeException extends Error {}
